const about = {
  about: {
    hero: {
      badge: 'About Us',
      title: 'Redefining Real Estate in Saudi Arabia',
      subtitle: 'Safaqat 24 is a next-generation real estate platform built to bring transparency, intelligence, and trust to the Saudi property market.',
    },
    mission: {
      title: 'Our Mission',
      description: 'To empower every individual, broker, and company in the Saudi real estate market with the tools, data, and connections they need to make confident property decisions - powered by technology, guided by trust.',
    },
    vision: {
      title: 'Our Vision',
      description: 'To become the most trusted and intelligent real estate platform in the Kingdom of Saudi Arabia, setting new standards for how properties are discovered, evaluated, and transacted.',
    },
    story: {
      title: 'Our Story',
      paragraphs: [
        'Safaqat 24 was founded in Jeddah with a clear purpose: the Saudi real estate market deserved better. Better tools for brokers. Better transparency for buyers. Better data for everyone.',
        'We noticed that property seekers often struggled with outdated listings, unreliable information, and fragmented communication. Brokers lacked modern tools to manage their operations efficiently. And the market as a whole lacked the transparency that builds trust.',
        'So we built Safaqat 24 - a comprehensive platform that combines advanced technology with deep understanding of the Saudi property landscape. From AI-powered search to verified broker networks, from market intelligence to seamless transactions, every feature was designed with our users in mind.',
        'Today, we serve property seekers, licensed brokers, agents, and real estate companies across the Kingdom, helping them navigate the market with confidence and clarity.',
      ],
    },
    values: {
      title: 'Our Values',
      items: [
        {
          icon: 'ri-shield-check-line',
          title: 'Trust & Transparency',
          description: 'Every broker is REGA-verified. Every listing is held to high standards. We believe trust is the foundation of every successful transaction.',
        },
        {
          icon: 'ri-lightbulb-flash-line',
          title: 'Innovation',
          description: 'From AI-powered property search to intelligent lead matching, we leverage cutting-edge technology to solve real problems in the real estate industry.',
        },
        {
          icon: 'ri-user-heart-line',
          title: 'User First',
          description: 'Whether you are a first-time renter or a seasoned broker, the platform is designed around your needs. Every feature exists because our users need it.',
        },
        {
          icon: 'ri-bar-chart-grouped-line',
          title: 'Data-Driven Decisions',
          description: 'We provide market intelligence, neighborhood analytics, and property insights so every decision is informed by reliable, up-to-date data.',
        },
        {
          icon: 'ri-scales-3-line',
          title: 'Compliance & Integrity',
          description: 'We operate in full compliance with REGA regulations, Saudi data protection laws, and industry best practices. Integrity is non-negotiable.',
        },
        {
          icon: 'ri-hand-heart-line',
          title: 'Community Impact',
          description: 'We are committed to supporting Vision 2030 by making property ownership and investment more accessible to all residents of the Kingdom.',
        },
      ],
    },
    platform: {
      title: 'What We Offer',
      subtitle: 'A complete ecosystem for the Saudi real estate market',
      features: [
        {
          icon: 'ri-search-eye-line',
          title: 'Smart Property Search',
          description: 'AI-powered search that understands what you are looking for, with advanced filters, map-based exploration, and natural language queries in Arabic and English.',
        },
        {
          icon: 'ri-verified-badge-line',
          title: 'Verified Broker Network',
          description: 'All brokers are verified through REGA and FAL license integration. Work with professionals you can trust.',
        },
        {
          icon: 'ri-line-chart-line',
          title: 'Market Intelligence',
          description: 'Neighborhood scores, walkability ratings, school quality, safety indices, and real-time market velocity metrics to guide your decisions.',
        },
        {
          icon: 'ri-exchange-funds-line',
          title: 'Lead Marketplace',
          description: 'A dynamic marketplace connecting property seekers with the right brokers - with free, paid, exclusive, and AI-matched lead options.',
        },
        {
          icon: 'ri-robot-2-line',
          title: 'AI Assistant',
          description: 'A bilingual chat assistant that helps you find properties, schedule viewings, and get instant answers to your real estate questions.',
        },
        {
          icon: 'ri-panorama-2-line',
          title: 'Virtual Tours',
          description: '360-degree panoramic property tours that let you explore homes from anywhere, anytime.',
        },
        {
          icon: 'ri-money-dollar-circle-line',
          title: 'Commission Management',
          description: 'Transparent commission tracking, automated calculations, and seamless payment processing for every transaction.',
        },
        {
          icon: 'ri-customer-service-2-line',
          title: 'Expert Consultations',
          description: 'Book one-on-one consultation sessions with real estate experts for personalized guidance on buying, selling, or investing.',
        },
      ],
    },
    compliance: {
      title: 'Regulated & Compliant',
      description: 'We operate under the oversight of the Real Estate General Authority (REGA) and in full compliance with Saudi Arabian laws and regulations.',
      items: [
        'Licensed under REGA with valid FAL authorization',
        'Compliant with the Personal Data Protection Law (PDPL)',
        'Adherent to E-Commerce Law regulations',
        'VAT-registered with ZATCA at 15%',
        'Secure payment processing via Moyasar',
      ],
    },
    stats: {
      title: 'Safaqat 24 at a Glance',
      items: [
        { value: 'Jeddah', label: 'Headquartered' },
        { value: '24/7', label: 'Platform Availability' },
        { value: 'AR/EN', label: 'Bilingual Support' },
        { value: 'REGA', label: 'Licensed & Regulated' },
      ],
    },
    cta: {
      title: 'Ready to Get Started?',
      description: 'Whether you are searching for your dream home, listing a property, or growing your brokerage business - Safaqat 24 is here for you.',
      primaryButton: 'Explore Properties',
      secondaryButton: 'Contact Us',
    },
    // Photo credits (/about#photo-credits). The list itself is src/config/photoCredits.ts.
    credits: {
      title: 'Photo credits',
      intro: 'We thank the photographers who shared their work under open licences.',
      editedNote: 'Photos marked edited were cropped, resized or colour-adjusted for the site.',
      by: 'Photo',
      licence: 'Licence',
      source: 'Source',
      edited: 'Edited',
      newTab: '(opens in a new tab)',
      sites: { commons: 'Wikimedia Commons' },
      usedOn: {
        cityCard: 'City card on the home page',
        hero: 'Home page header background',
      },
      subjects: {
        makkah: 'Masjid al-Haram, Makkah',
        madinah: 'Al-Masjid an-Nabawi, Madinah',
        riyadh: 'North Riyadh skyline',
        jeddah: 'Jeddah Corniche',
        dammam: 'Dammam Corniche',
        hero: 'Riyadh skyline',
      },
    },
  },
};

export default about;
